import React, { Component } from "react";
import GlassCard from '../GlassCard';
import '../../styles/css/App.css';
import '../../styles/css/board.css';


class Terrain extends Component{

    render(){
        return (
                <GlassCard
                   
                    body = {<div >
                            {this.props.body}
                           
                        </div>}
                >
                </GlassCard>
            )
    }
}


export default Terrain;